export default __webpack_public_path__ + "static/media/react-todo.0e86efd8.png";